<mat-form-field
        [appearance]="asFormsControl().outline ? 'outline' : 'legacy'"
        [floatLabel]="outlined ? 'always' : !asFormsControl().floatingLabelNever ? 'auto' : 'never'"
        class="app-password-input"
>
    <mat-label
            *ngIf="asFormsControl().outline && !asFormsControl().floatingLabelNever">{{ asFormsControl().placeholder }}</mat-label>

    <input
            matInput
            #input
            [placeholder]="asFormsControl().placeholder"
            [disabled]="disabled"
            [type]="passwordInputType"
            [autocomplete]="'off'"
            (focus)="onTouched && onTouched()"
			(change)="onKeyUp($event)"
			(keyup)="onKeyUp($event)"
            (keydown)="onKeyDown($event)"
            autocomplete="new-password"
    >
    <i
            matSuffix
            [ngClass]="passwordInputType !== inputComponentTypes.Text ? 'icon-eye-closed-1' : 'icon-eye-open-1'"
            (click)="changePasswordInputType($event)"

            aria-hidden="true"
            class="app-password-input-suffix"
    ></i>
    <mat-hint
            *ngIf="asFormsControl().errors.length === 0 && !asFormsControl().hintDisabled"

            align="start"
            class="app-password-input-hint"
    >
        <ul>
            <li
                    [ngClass]="{'valid': hasMinLength}"
            >
                <span>{{ 'CONTROLS.PASSWORD_VALIDATION_SYMBOLS_LENGTH' | translate }}</span>
            </li>
            <li
                    [ngClass]="{'valid': hasUppercase}"
            >
                <span>{{ 'CONTROLS.PASSWORD_VALIDATION_UPPERCASE' | translate }}</span>
            </li>
            <li
                    [ngClass]="{'valid': hasLowercase}"
            >
                <span>{{ 'CONTROLS.PASSWORD_VALIDATION_LOWERCASE' | translate }}</span>
            </li>
            <li
                    [ngClass]="{'valid': hasSpecialSymbol}"
            >
                <span>{{ 'CONTROLS.PASSWORD_VALIDATION_SYMBOL' | translate }}</span>
            </li>
            <li
                    [ngClass]="{'valid': hasNumber}"
            >
                <span>{{ 'CONTROLS.PASSWORD_VALIDATION_NUMBER' | translate }}</span>
            </li>
        </ul>
    </mat-hint>
</mat-form-field>
<div *ngIf='asFormsControl().errors.length > 0' class="form-text text-danger">
    <span *ngFor="let error of asFormsControl().errors">{{error}}</span>
</div>

